import {IconButton} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import React, {useEffect, useState} from 'react';
import {firestore} from '../../Firebase';
import Heading from '../../Heading/JavaScript/Heading';
import GalleryCard from './GalleryCard';

function Gallery() {
    const [disable, setDisable] = useState(false);
    const [moreLess, setMoreLess] = useState('More');
    const [galleryData, setGalleryData] = useState([]);
    const [first6Images, setFirst6Images] = useState([]);
    
    useEffect(
        () => {
            firestore.collection("Gallery").onSnapshot(
                (snapShot) => (
                    setGalleryData(
                        snapShot.docs.map(
                            (doc) => (
                                {
                                    imageURL: doc.data().imageURL
                                }
                            )
                        )
                    )
                )
            )
        }, []
    )
    
    useEffect(
        () => {
            const temp = galleryData.slice(0, 6);
            
            setFirst6Images(
                temp.map(
                    (doc) => (
                        {
                            imageURL: doc.imageURL,
                        }
                    )
                )
            )
        }, [galleryData]
    )
    
    useEffect(
        () => {
            if (galleryData.length === 0) {
                let gallerySection = document.getElementsByClassName("gallery")[0];
                
                gallerySection.style.display = "none";
            }
            else {
                let gallerySection = document.getElementsByClassName("gallery")[0];
                
                gallerySection.style.display = "grid";
            }
        }, [galleryData.length]
    )
    
    const expand = () => {
        let galleryExpandButton = document.getElementsByClassName("gallery__expand__button")[0];
        
        if (galleryData.length <= 6) {
            setDisable(true);
        }
        else {
            setDisable(false);
        }
        
        if (moreLess === "More") {
            galleryExpandButton.style.transform = "rotate(180deg)";
            setMoreLess("Less");
        }
        else {
            galleryExpandButton.style.transform = "rotate(0deg)";
            setMoreLess("More");
        }
    }
    
    return (
        <section className="gallery">
            <div className="gallery__heading">
                <Heading text="Gallery" />
            </div>
            
            <div className="gallery__container">
                {
                    (moreLess === "Less") ? (
                        React.Children.toArray(
                            galleryData.map(
                                (image) => (
                                    <GalleryCard img={image.imageURL} />
                                )
                            )
                        )
                    ) : (
                        React.Children.toArray(
                            first6Images.map(
                                (image) => (
                                    <GalleryCard img={image.imageURL} />
                                )
                            )
                        )
                    )
                }
            </div>
            
            <IconButton className="gallery__expand" onClick={expand} disabled={disable} data-aos="fade-down" data-aos-delay="4s00">
                <span className="gallery__expand__text">Show {moreLess}</span>
                <ExpandMoreIcon className="gallery__expand__button" />
            </IconButton>
        </section>
    )
}

export default Gallery
